(function () {
    var section = document.getElementById('guitar-parts-section');
    if (!section) return;

    var track = section.querySelector('.gp-track');
    var panels = Array.prototype.slice.call(section.querySelectorAll('.gp-panel'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.gp-dot'));
    var HALF_PI = Math.PI / 2;

    var keyframes = [
        { p: 0.00, alpha: HALF_PI, beta: HALF_PI, radius: 2.05, ty: 0.000, part: null },
        { p: 0.20, alpha: HALF_PI + 0.30, beta: HALF_PI, radius: 1.02, ty: -0.232, part: 'body' },
        { p: 0.42, alpha: HALF_PI - 0.18, beta: HALF_PI, radius: 1.12, ty: 0.142, part: 'neck' },
        { p: 0.60, alpha: HALF_PI + 0.30, beta: HALF_PI, radius: 0.74, ty: -0.245, part: 'pickups' },
        { p: 0.78, alpha: HALF_PI - 0.24, beta: HALF_PI, radius: 0.78, ty: -0.302, part: 'bridge' },
        { p: 0.92, alpha: 3 * HALF_PI, beta: HALF_PI, radius: 0.90, ty: -0.288, part: 'electronics' },
        { p: 1.00, alpha: HALF_PI, beta: HALF_PI, radius: 2.05, ty: 0.000, part: null }
    ];

    var stageBoundaries = [0.10, 0.31, 0.51, 0.69, 0.85];
    var H_OFFSET = 0.11;
    var PANEL_FRACTION = 0.40;
    var MAX_TEXT_BAND = 0.45;
    var PANEL_FADE = 56;
    var PRELOAD_DELAY = 2500;
    var PAINT_GRACE = 400;
    var BOOT_FLOOR = 1200;
    var HEADER_H_WIDE = 85;
    var HEADER_H_NARROW = 65;
    var BASE_RADIUS = 2.05;
    var PROJ_K = 1.766;
    var GUITAR_K = 1.66;
    var FIT_MARGIN = 0.94;

    var GROUP_DIST = {
        body: 0,
        neck: 1.60,
        pickups: 1.30,
        stringset: 1.40,
        elecFront: 1.30,
        elecRear: 1.30
    };
    var FADE_PORTION = 0.35;
    var PART_KEYS = ['body', 'neck', 'pickups', 'stringset', 'elecFront', 'elecRear'];
    var STAGE_PARTS = [
        ['body', 'neck', 'pickups', 'stringset', 'elecFront', 'elecRear'],
        ['body'],
        ['body', 'neck'],
        ['body', 'neck', 'pickups'],
        ['body', 'neck', 'pickups', 'stringset'],
        ['body', 'neck', 'pickups', 'stringset', 'elecFront', 'elecRear']
    ];
    var APPEAR_DURATION = 600;

    var partData = {};
    var appearTarget = {};
    var appearCurrent = {};
    var appearT = {};
    var meshesCached = false;
    var cachedMeshCount = -1;
    for (var pk = 0; pk < PART_KEYS.length; pk++) {
        partData[PART_KEYS[pk]] = { vis: [], movers: [] };
        appearTarget[PART_KEYS[pk]] = 1;
        appearCurrent[PART_KEYS[pk]] = 1;
        appearT[PART_KEYS[pk]] = 1;
    }

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }
    function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function lerp(a, b, t) { return a + (b - a) * t; }

    function isWide() { return window.innerWidth > 991; }

    function pinHeight() {
        var vp = section.querySelector('.gp-viewport');
        return (vp && vp.offsetHeight) || window.innerHeight;
    }

    var bandCache = {};
    var panelsEl = section.querySelector('.gp-panels');
    var panelsHeightSet = '';

    function reservedBottom(vh) {
        if (isWide()) {
            if (panelsEl && panelsHeightSet !== '') { panelsEl.style.height = ''; panelsHeightSet = ''; }
            return 0;
        }
        var idx = lastStage < 0 ? 0 : lastStage;
        var val = bandCache[idx];
        if (val == null) {
            var h = panels[idx] ? panels[idx].offsetHeight : 0;
            val = h ? Math.min(vh * MAX_TEXT_BAND, h + 16) : vh * PANEL_FRACTION;
            bandCache[idx] = val;
        }
        if (panelsEl) {
            var next = Math.round(val + PANEL_FADE) + 'px';
            if (next !== panelsHeightSet) { panelsEl.style.height = next; panelsHeightSet = next; }
        }
        return val;
    }

    function usableBand(vh, wide) {
        var top = wide ? HEADER_H_WIDE : HEADER_H_NARROW;
        var bottom = vh - reservedBottom(vh);
        return { top: top, height: bottom - top };
    }

    function vOffsetCoef(vh, wide) {
        var band = usableBand(vh, wide);
        if (band.height <= 0) return 0;
        return ((band.top + band.height / 2) - vh / 2) / (-PROJ_K * vh);
    }

    function radiusScale() {
        if (isWide()) return 1;
        var vh = pinHeight();
        var band = usableBand(vh, false);
        var target = band.height * FIT_MARGIN;
        if (target <= 0) return 1.09;
        return clamp((GUITAR_K * vh) / (target * BASE_RADIUS), 1, 1.9);
    }

    function poseAt(progress) {
        var i = 0;
        for (; i < keyframes.length - 1; i++) {
            if (progress <= keyframes[i + 1].p) break;
        }
        var a = keyframes[i];
        var b = keyframes[Math.min(i + 1, keyframes.length - 1)];
        var span = b.p - a.p;
        var t = span <= 0 ? 0 : easeInOutCubic(clamp((progress - a.p) / span, 0, 1));
        var rs = radiusScale();
        return {
            alpha: lerp(a.alpha, b.alpha, t),
            beta: lerp(a.beta, b.beta, t),
            radius: lerp(a.radius, b.radius, t) * rs,
            ty: lerp(a.ty, b.ty, t)
        };
    }

    function stageIndex(progress) {
        var idx = 0;
        for (var i = 0; i < stageBoundaries.length; i++) {
            if (progress >= stageBoundaries[i]) idx = i + 1;
        }
        return idx;
    }

    var lastStage = -1;
    function setStage(idx) {
        if (idx === lastStage) return;
        lastStage = idx;
        for (var i = 0; i < panels.length; i++) {
            panels[i].classList.toggle('is-active', i === idx);
        }
        for (var d = 0; d < dots.length; d++) {
            dots[d].classList.toggle('is-active', d === idx);
        }
        applyStageVisibility(idx);
    }

    var UP, FRONT, BACK;

    function hasAncestorIn(mesh, set) {
        var p = mesh.parent;
        while (p) {
            if (set.indexOf(p) >= 0) return true;
            p = p.parent;
        }
        return false;
    }

    function flatten(roots) {
        var all = [];
        for (var r = 0; r < roots.length; r++) {
            if (all.indexOf(roots[r]) < 0) all.push(roots[r]);
            var kids = roots[r].getChildMeshes ? roots[r].getChildMeshes() : [];
            for (var c = 0; c < kids.length; c++) {
                if (all.indexOf(kids[c]) < 0) all.push(kids[c]);
            }
        }
        return all;
    }

    function topLevel(set) {
        var res = [];
        for (var i = 0; i < set.length; i++) {
            if (!hasAncestorIn(set[i], set)) res.push(set[i]);
        }
        return res;
    }

    function isStringMesh(m) { return m.name && m.name.indexOf('Strings') >= 0; }

    function subtreeIsStrings(anchor) {
        var sub = [anchor].concat(anchor.getChildMeshes ? anchor.getChildMeshes() : []);
        var geom = sub.filter(function (m) { return m.getTotalVertices && m.getTotalVertices() > 0; });
        if (!geom.length) return false;
        return geom.every(isStringMesh);
    }

    function centerZ(m) {
        try { m.computeWorldMatrix(true); return m.getBoundingInfo().boundingBox.centerWorld.z; }
        catch (e) { return 0; }
    }

    function localDirFor(mesh, worldDir) {
        if (mesh.parent && mesh.parent.getWorldMatrix) {
            mesh.parent.computeWorldMatrix(true);
            return BABYLON.Vector3.TransformNormal(worldDir, mesh.parent.getWorldMatrix().clone().invert());
        }
        return worldDir.clone();
    }

    function restOf(mesh) {
        if (!mesh.__restPos) { mesh.computeWorldMatrix(true); mesh.__restPos = mesh.position.clone(); }
        return mesh.__restPos;
    }

    function moversFrom(anchors, worldDir) {
        return anchors.map(function (m) {
            return { mesh: m, rest: restOf(m), dir: localDirFor(m, worldDir) };
        });
    }

    function buildGroups() {
        var S = window.scene;
        if (!S || !S.getMeshesByTags || typeof BABYLON === 'undefined') return;
        if (meshesCached && S.meshes.length === cachedMeshCount) return;
        if (!UP) { UP = new BABYLON.Vector3(0, 1, 0); FRONT = new BABYLON.Vector3(0, 0, 1); BACK = new BABYLON.Vector3(0, 0, -1); }

        var bodyFull = flatten(S.getMeshesByTags('BodyPart || BodyWoodPart'));
        var pickupModules = [];
        var bodySet = bodyFull.filter(function (m) {
            if (/^Pu /.test(m.name) && !/Frame/i.test(m.name)) { pickupModules.push(m); return false; }
            return true;
        });
        partData.body = { vis: bodySet, movers: [] };

        var neckFull = flatten(S.getMeshesByTags('NeckPart'));
        var stringMeshes = [];
        var neckVis = neckFull.filter(function (m) {
            if (isStringMesh(m)) { stringMeshes.push(m); return false; }
            return true;
        });
        var neckAnchors = topLevel(neckVis).filter(function (a) { return !subtreeIsStrings(a); });
        partData.neck = { vis: neckVis, movers: moversFrom(neckAnchors, UP) };

        var puSet = flatten(S.getMeshesByTags('NeckPickupPart || BridgePickupPart'));
        for (var pm = 0; pm < pickupModules.length; pm++) {
            if (puSet.indexOf(pickupModules[pm]) < 0) puSet.push(pickupModules[pm]);
        }
        partData.pickups = { vis: puSet, movers: moversFrom(topLevel(puSet), BACK) };

        var bridgeSet = flatten(S.getMeshesByTags('BridgePart'));
        var nutSet = flatten(S.getMeshesByTags('NutPart'));
        var stringFull = flatten(stringMeshes);
        var ssVis = [];
        [bridgeSet, nutSet, stringFull].forEach(function (arr) {
            arr.forEach(function (m) { if (ssVis.indexOf(m) < 0) ssVis.push(m); });
        });
        partData.stringset = { vis: ssVis, movers: moversFrom(topLevel(ssVis), FRONT) };

        var elecFull = flatten(S.getMeshesByTags('ElectronicsPart'));
        var refZ = -0.026;
        var bodyGeom = bodySet.filter(function (m) { return m.getTotalVertices && m.getTotalVertices() > 0; });
        if (bodyGeom.length) {
            var sum = 0; bodyGeom.forEach(function (m) { sum += centerZ(m); });
            refZ = sum / bodyGeom.length;
        }
        var frontVis = [], rearVis = [], frontAnc = [], rearAnc = [];
        elecFull.forEach(function (m) {
            var geom = m.getTotalVertices && m.getTotalVertices() > 0;
            if (!geom) { frontVis.push(m); rearVis.push(m); return; }
            if (centerZ(m) > refZ) { frontVis.push(m); frontAnc.push(m); }
            else { rearVis.push(m); rearAnc.push(m); }
        });
        partData.elecFront = { vis: frontVis, movers: moversFrom(frontAnc, FRONT) };
        partData.elecRear = { vis: rearVis, movers: moversFrom(rearAnc, BACK) };

        if (bodySet.length) { meshesCached = true; cachedMeshCount = S.meshes.length; }
    }

    function applyStageVisibility(idx) {
        if (reduceMotion) return;
        buildGroups();
        var set = STAGE_PARTS[idx] || STAGE_PARTS[0];
        for (var i = 0; i < PART_KEYS.length; i++) {
            var key = PART_KEYS[i];
            appearTarget[key] = set.indexOf(key) >= 0 ? 1 : 0;
        }
        requestFrame();
    }

    function animateParts(dt) {
        var moving = false;
        var step = dt / APPEAR_DURATION;
        for (var i = 0; i < PART_KEYS.length; i++) {
            var key = PART_KEYS[i];
            var tgt = appearTarget[key];
            var t = appearT[key];
            if (t !== tgt) {
                t = t < tgt ? Math.min(tgt, t + step) : Math.max(tgt, t - step);
                appearT[key] = t;
                moving = true;
            }
            var cur = easeInOutCubic(t);
            appearCurrent[key] = cur;
            var d = partData[key];
            if (!d) continue;
            var off = (1 - cur) * GROUP_DIST[key];
            for (var a = 0; a < d.movers.length; a++) {
                var mv = d.movers[a];
                if (!mv.rest) continue;
                mv.mesh.position.set(mv.rest.x + mv.dir.x * off, mv.rest.y + mv.dir.y * off, mv.rest.z + mv.dir.z * off);
            }
            var op = clamp(t / FADE_PORTION, 0, 1);
            var visible = op > 0.01;
            for (var v = 0; v < d.vis.length; v++) {
                d.vis[v].visibility = op;
                d.vis[v].isVisible = visible;
            }
        }
        return moving;
    }

    var viewport = section.querySelector('.gp-viewport');

    function computeProgress() {
        var r = track.getBoundingClientRect();
        var pinH = viewport.offsetHeight || window.innerHeight;
        var denom = r.height - pinH;
        if (denom <= 0) return 0;
        return clamp(-r.top / denom, 0, 1);
    }

    if (reduceMotion) {
        section.classList.add('gp-reduced');
        setStage(0);
    }

    var booted = false;
    var scriptsInjected = false;
    var cameraReady = false;
    var current = null;
    var target = null;
    var needsUpdate = true;
    var rafId = null;
    var lastTick = 0;
    var enginePaused = false;

    function injectScripts() {
        if (scriptsInjected || window.__productViewScriptsLoading) {
            if (window.__pendingDesignData == null && typeof window.initProductRenderer === 'function') {
                fetchAndInit();
            }
            return;
        }
        scriptsInjected = true;
        window.__productViewScriptsLoading = true;
        window.__pendingDesignData = null;
        window.initProductRenderer = function (designData) { window.__pendingDesignData = designData; };
        window.resetProductRenderer = function () {};

        productData();

        var scripts = [
            'https://cdn.jsdelivr.net/npm/babylonjs@9.26.2/babylon.js',
            'https://cdn.jsdelivr.net/npm/babylonjs-loaders@9.26.2/babylonjs.loaders.min.js',
            '/js/texture-variants.min.js',
            '/js/fretboard-binding.min.js',
            '/js/product-view/product-data.min.js',
            '/js/product-view/product-parts.min.js',
            '/js/product-view/product-renderer.min.js'
        ];
        var last = scripts.length - 1;
        scripts.forEach(function (src, i) {
            var s = document.createElement('script');
            s.src = src;
            s.async = false;
            s.setAttribute('fetchpriority', 'high');
            if (i === last) { s.onload = fetchAndInit; }
            document.head.appendChild(s);
        });
    }

    var dataPromise = null;
    function productData() {
        if (!dataPromise) {
            var code = section.getAttribute('data-product-code');
            dataPromise = fetch('/api/store/getSingleProduct?product_code=' + encodeURIComponent(code))
                .then(function (res) { return res.json(); });
        }
        return dataPromise;
    }

    function tuneSceneForLoad(tries) {
        var S = window.scene;
        if (!S) {
            if (tries < 200) { setTimeout(function () { tuneSceneForLoad(tries + 1); }, 20); }
            return;
        }
        if (S.__gpTuned) return;
        S.__gpTuned = true;
        S.blockMaterialDirtyMechanism = true;
        S.useMaterialMeshMap = true;
        S.useGeometryUniqueIdsMap = true;
        S.useClonedMeshMap = true;
    }

    function releaseSceneTuning() {
        var S = window.scene;
        if (S && S.__gpTuned) { S.blockMaterialDirtyMechanism = false; }
    }

    function fetchAndInit() {
        productData()
            .then(function (data) {
                var props = (data && data.properties) || (data && data.data && data.data.properties);
                if (!props || !props.length) throw new Error('no properties');
                if (typeof window.initProductRenderer === 'function') {
                    window.initProductRenderer(props);
                }
                tuneSceneForLoad(0);
                waitForCamera(0);
            })
            .catch(function () { section.style.display = 'none'; });
    }

    function waitForCamera(tries) {
        if (tries > 100) return;
        if (window.productCamera && window.engine) {
            applyCameraOverrides();
            return;
        }
        setTimeout(function () { waitForCamera(tries + 1); }, 100);
    }

    function applyCameraOverrides() {
        var cam = window.productCamera;
        cam.useAutoRotationBehavior = false;
        if (cam.autoRotationBehavior) { cam.autoRotationBehavior.idleRotationSpeed = 0; }
        cam.lowerRadiusLimit = 0.4;
        cam.upperRadiusLimit = 2.3;
        cam.minZ = 0.05;
        cam.lowerBetaLimit = null;
        cam.upperBetaLimit = null;
        cam.lowerAlphaLimit = null;
        cam.upperAlphaLimit = null;
        if (cam.detachControl) { cam.detachControl(); }
        var canvas = document.getElementById('productRenderCanvas');
        if (canvas) { canvas.style.touchAction = 'pan-y'; }
        cameraReady = true;
        var p = computeProgress();
        current = poseAt(p);
        target = poseAt(p);
        writePose(current);
        if (typeof window.productRendererFireReady === 'function') { window.productRendererFireReady(); }
        if (!reduceMotion && window.scene && window.scene.executeWhenReady) {
            window.scene.executeWhenReady(function () {
                releaseSceneTuning();
                buildGroups();
                applyStageVisibility(stageIndex(computeProgress()));
                requestFrame();
            });
        }
        needsUpdate = true;
        startLoop();
    }

    function writePose(pose) {
        var cam = window.productCamera;
        if (!cam) return;
        cam.alpha = pose.alpha;
        cam.beta = pose.beta;
        if (cam.upperRadiusLimit && cam.upperRadiusLimit < pose.radius) { cam.upperRadiusLimit = pose.radius; }
        if (cam.lowerRadiusLimit && cam.lowerRadiusLimit > pose.radius) { cam.lowerRadiusLimit = pose.radius; }
        cam.radius = pose.radius;
        if (cam.target && cam.target.set) { cam.target.set(0, pose.ty, 0); }
        if (cam.targetScreenOffset) {
            var wide = isWide();
            cam.targetScreenOffset.x = wide ? H_OFFSET * pose.radius : 0;
            cam.targetScreenOffset.y = vOffsetCoef(pinHeight(), wide) * pose.radius;
        }
    }

    function startLoop() {
        if (rafId != null) return;
        lastTick = 0;
        rafId = requestAnimationFrame(tick);
    }

    function tick(now) {
        rafId = null;
        if (!cameraReady) return;

        var ts = now || performance.now();
        var dt = lastTick ? Math.min(ts - lastTick, 50) : 16.7;
        lastTick = ts;

        var progress = computeProgress();
        target = poseAt(progress);
        setStage(stageIndex(progress));

        var damping = 0.15;
        var settled = true;
        var keys = ['alpha', 'beta', 'radius', 'ty'];
        for (var k = 0; k < keys.length; k++) {
            var key = keys[k];
            current[key] = lerp(current[key], target[key], damping);
            if (Math.abs(current[key] - target[key]) > 0.0004) settled = false;
        }
        writePose(current);

        if (!reduceMotion && meshesCached) {
            if (animateParts(dt)) settled = false;
        }

        if (!settled || needsUpdate) {
            needsUpdate = false;
            rafId = requestAnimationFrame(tick);
        }
    }

    function requestFrame() {
        needsUpdate = true;
        startLoop();
    }

    function setEnginePaused(paused) {
        if (!window.engine || enginePaused === paused) return;
        enginePaused = paused;
        if (paused) {
            window.engine.stopRenderLoop();
        } else {
            window.engine.runRenderLoop(function () { if (window.scene) window.scene.render(); });
        }
    }

    if (!reduceMotion) {
        window.addEventListener('scroll', requestFrame, { passive: true });
        window.addEventListener('resize', function () { bandCache = {}; requestFrame(); }, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', requestFrame, { passive: true });
        }

        var inView = false;
        var engaged = false;

        function whenIdle(fn, timeout) {
            if (window.requestIdleCallback) { requestIdleCallback(fn, { timeout: timeout || 1500 }); }
            else { setTimeout(fn, 0); }
        }

        var prefetched = false;
        function prefetchScripts() {
            if (prefetched || scriptsInjected) return;
            prefetched = true;
            var hrefs = [
                'https://cdn.jsdelivr.net/npm/babylonjs@9.26.2/babylon.js',
                'https://cdn.jsdelivr.net/npm/babylonjs-loaders@9.26.2/babylonjs.loaders.min.js',
                '/js/texture-variants.min.js',
                '/js/fretboard-binding.min.js',
                '/js/product-view/product-data.min.js',
                '/js/product-view/product-parts.min.js',
                '/js/product-view/product-renderer.min.js'
            ];
            for (var i = 0; i < hrefs.length; i++) {
                var link = document.createElement('link');
                link.rel = 'preload';
                link.as = 'script';
                link.href = hrefs[i];
                document.head.appendChild(link);
            }
        }

        function paintFloor() {
            var fcp = 0;
            try {
                var e = performance.getEntriesByName('first-contentful-paint')[0];
                fcp = e ? e.startTime : 0;
            } catch (err) { fcp = 0; }
            return (fcp ? fcp + PAINT_GRACE : BOOT_FLOOR) - performance.now();
        }

        function tryBoot() {
            if (booted || !inView || !engaged) return;
            booted = true;
            var wait = paintFloor();
            if (wait > 0) { setTimeout(injectScripts, wait); }
            else { injectScripts(); }
        }

        function engage() {
            if (engaged) return;
            engaged = true;
            tryBoot();
        }

        ['scroll', 'wheel', 'touchstart', 'pointerdown', 'pointermove', 'mousemove', 'keydown'].forEach(function (evt) {
            window.addEventListener(evt, engage, { passive: true, once: true });
        });

        var preconnect = document.createElement('link');
        preconnect.rel = 'preconnect';
        preconnect.href = 'https://cdn.jsdelivr.net';
        document.head.appendChild(preconnect);

        var conn = navigator.connection;
        if (!conn || (!conn.saveData && !/(^|-)2g$/.test(conn.effectiveType || ''))) {
            setTimeout(function () { whenIdle(prefetchScripts, 2000); }, PRELOAD_DELAY);
        }

        if (window.scrollY > 0) engage();

        var bootObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                inView = e.isIntersecting;
                if (e.isIntersecting) {
                    tryBoot();
                    setEnginePaused(false);
                    requestFrame();
                } else if (booted && cameraReady) {
                    setEnginePaused(true);
                }
            });
        }, { rootMargin: '60% 0px' });
        bootObserver.observe(section);
    } else {
        var reducedObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (e.isIntersecting && !booted) { booted = true; injectScripts(); }
            });
        }, { rootMargin: '200px 0px' });
        reducedObserver.observe(section);

        var stageObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (e.isIntersecting) {
                    var idx = panels.indexOf(e.target);
                    if (idx >= 0 && cameraReady) { writePose(poseAt(keyframes[idx] ? keyframes[idx].p : 0)); }
                }
            });
        }, { threshold: 0.5 });
        panels.forEach(function (panel) { stageObserver.observe(panel); });
    }
})();
